// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  activityLogs: [],
  totalActivityLogs: 0
}

export const mutations = {
  SET_ACTIVITY_LOGS(state, activityLogs) {
    state.activityLogs = activityLogs
  },
  SET_TOTAL_ACTIVITY_LOGS(state, totalActivityLogs) {
    state.totalActivityLogs = totalActivityLogs
  }
}

export const actions = {
  getActivityLogs({ commit }, payload) {
    return ApiService.getActivityLogs(payload)
      .then(res => {
        const results = res.data

        commit('SET_ACTIVITY_LOGS', results.activity_logs)
        commit('SET_TOTAL_ACTIVITY_LOGS', results.total)
      })
      .catch(error => {
        throw error
      })
  }
}
